import axios from 'axios';
import { apiHost } from '../config';

const client = axios.create({ baseURL: apiHost });

export { client };
